import '../lib/globals/babel'
import '../lib/chunk_load_handler'

import loadPolyfills from '../lib/polyfills'
import { addInstallPromptListener } from './util/pwa'
import detectUnsupportedIE from '../lib/util/detect_unsupported_ie'

import '../lib/init.scss'

async function bootApp () {
  const opts = {
    role: 'participant',
    appName: 'Poll Everywhere Participant',
    supportIE11: false,
    useApiProxy: true
  }

  const startAppLoader = (await import(/* webpackChunkName: "start-app" */ './util/startApp'))
  addInstallPromptListener()
  startAppLoader.startApp(opts)
}

loadPolyfills().then(async () => {
  const IEVersion = detectUnsupportedIE()
  if (IEVersion) {
    const unsupportedMessage = (await import(/* webpackChunkName: 'unsupported-message' */ './util/unsupportedMessage')).unsupportedMessage
    unsupportedMessage('Poll Everywhere Participant')
  } else if (navigator.onLine) {
    bootApp()
  } else {
    const offlineMessage = (await import(/* webpackChunkName: 'offline-message' */ './util/offlineMessage')).offlineMessage
    offlineMessage('Poll Everywhere Participant')
  }
})
